import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { SCREEN_ID_HOUSEHOLD_INVITE_GUARANTOR_SENT } from 'client/constants/screenIds';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import branch from 'client/core/branch';

import HouseholdActions from 'client/actions/Household';
import ButtonDeprecated from 'client/components/ButtonDeprecated';

@branch()
@withTransitionHook
@withScreenId(SCREEN_ID_HOUSEHOLD_INVITE_GUARANTOR_SENT)
@withScrollToTop
@branch()
class HouseholdInviteGuarantorSent extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Guarantors Invited | Sunroom Rentals',
  })

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
  }

  _onOkClick = () => {
    const {
      match,
      dispatch,
    } = this.props;

    const listingId = parseInt(match.params.listingId, 10);

    dispatch(HouseholdActions.roommateApplicationStep, {
      listingId,
    });
  }

  render() {
    return (
      <div className='page-inviteGuarantor'>
        <div className='modal success'>
          <div className='contentContainer'>
            <div className='heroIcon emailSent' />
            <div className='textContainer'>
              <span className='headline'>Guarantors invited!</span>
              <span className='explainer'>
                {
                  'We emailed & texted your guarantors links to complete their own guarantor ' +
                  'applications. Each guarantor needs to do their own application.'
                }
              </span>
            </div>
            <ButtonDeprecated onClick={this._onOkClick}>
              continue
            </ButtonDeprecated>
          </div>
        </div>
      </div>
    );
  }
}

HouseholdInviteGuarantorSent.displayName = 'HouseholdInviteGuarantorSent';

export default HouseholdInviteGuarantorSent;
